import api from '../_api';

export const institutionService = {
  getStats(id, range) {
    return api.get(`/institution/${id}/stats_range/`, {
      params: { range },
    });
  },
  getSalesOverview(id) {
    return api.get(`/institution/${id}/sales_overview/`);
  },
  getDeviceOpens(id, range) {
    return api.get(`/institution/${id}/device_stats_range/`, {
      params: { range },
    });
  },
  getCustomSalesOverview(url, range) {
    return api.get(url, { params: { range } });
  },
  getTemplates(id) {
    return api.get(`/institution/${id}/templates/`);
  },
};
